module.exports = __webpack_public_path__ + "static/media/1000Mbps.f1baa403.bin";